import { atom } from 'recoil';

import { DateTime } from './types';
import React from 'react';

export const dateTimeState = atom<DateTime | undefined>({
  key: 'dateTimeState',
  default: undefined,
});

export const serverTimeState = atom<DateTime | undefined>({
  key: "serverTime",
  default: undefined
})

interface ObsDatetime {
  [id: string]: DateTime
}

export const obsDatetimeState = atom<ObsDatetime>({
  key: "obsDatetimeState",
  default: undefined
})

export const modalState = atom<React.ReactNode>({
  key: "modalState",
  default: undefined
})